<template>
  <div class="blogpost-single">
    <div class="container">
      <b-img
        :src="blogpost.featured_image.url"
        fluid
        :alt="blogpost.title"
        v-if="blogpost.featured_image.url"
      />
      <div class="blogpost-content">
        <div class="blogpost-header">
          <h1>{{blogpost.title}}</h1>
          <span class="time">{{blogpost.published_at}}</span>
        </div>

        <div class="content" v-html="blogpost.content"></div>

        <div v-if="blogpost && blogpost.responses && blogpost.responses.length > 0">
          <h5>respostas ({{blogpost.responses.length}})</h5>
          <div class="forum-responses">
            <div
              class="forum-response"
              v-for="forum_response in blogpost.responses"
              :key="forum_response.id"
            >
              <b-media>
                <b-img
                  :src="forum_response.user.avatar.url"
                  slot="aside"
                  width="64"
                  height="64"
                  alt="placeholder"
                />
                <p v-html="forum_response.content"></p>
                <div class="response-footer">
                  postado por
                  <router-link
                    :to="{ name: 'UserSingle', params: { id: forum_response.user.id }}"
                  >{{forum_response.user.nickname}}</router-link>em
                  <span v-html="forum_response.created_at_friendly"></span>

                  <div v-if="respondEnabled && forum_response.user.id == currentUser.id">
                    <b-btn
                      v-on:click.stop.prevent="deleteComment(forum_response.id)"
                      size="sm"
                      variant="outline-danger"
                    >apagar</b-btn>
                  </div>
                </div>
              </b-media>
            </div>
          </div>
        </div>

        <div class="forum-respond" v-if="respondEnabled">
          <form @submit.stop.prevent="handleReplySubmit">
            <b-form-group description label="responda a este tópico">
              <ckeditor
                required
                :editor="editor"
                v-model="forum_response.content"
                :config="editorConfig"
              ></ckeditor>
            </b-form-group>
            <b-button type="submit" variant="primary">responder</b-button>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="sass">
.blogpost-single
  .container
    .blogpost-content
      background: rgba(255, 255, 255, .02)
      border-left: 1px solid rgba(255, 255, 255, .02)
      border-right: 1px solid rgba(255, 255, 255, .02)
      border-bottom: 1px solid rgba(255, 255, 255, .02)
      border-bottom-left-radius: 4px
      border-bottom-right-radius: 4px
      padding: 20px

      .blogpost-header
        padding: .5em 0 2em
        text-align: center
        margin: .5em 0 2em

      .content
        @media (max-width: 600px)
          img
            width: 100% !important
            height: auto !important
        p,span
          color: white !important

    .forum-response
      margin: 5px 0
      padding: 5px
      background: rgba(255, 255, 255, .04)
      border-radius: 5px
      .response-footer
        font-size: 12px
        border-top: 1px solid #ccc
        padding: 5px 0 5px
</style>


<script>
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
export default {
  name: "BlogpostSingle",
  data() {
    return {
      blogpost: { featured_image: "", title: "", id: 0, responses: [] },
      forum_response: { content: "" },
      respondTimeout: Object,
      editor: ClassicEditor,
      editorData: "<p>Content of the editor.</p>",
      editorConfig: {
        toolbar: {
          items: ["bold", "italic", "link", "undo", "redo"]
        }
      }
    };
  },
  computed: {
    currentUser: function() {
      return this.$store.getters.user;
    },
    respondEnabled: function() {
      return this.$store.getters.isLoggedIn;
    }
  },
  metaInfo() {
    return {
      title: `${this.blogpost.title}`
    };
  },
  methods: {
    initialize() {
      this.$http
        .get("blog/" + this.$route.params.id + ".json")
        .then(response => (this.blogpost = response.data));
    },

    deleteComment(forum_response_id) {
      if (
        confirm(
          "Você tem certeza que deseja apagar esse comentário?\nAVISO: Essa ação não terá retorno."
        )
      ) {
        this.$http
          .delete(
            `forum_posts/${
              this.$route.params.id
            }/forum_responses/${forum_response_id}.json`
          )
          .then(response => {
            this.$notify({
              group: "all",
              title: "Comentário apagado com sucesso"
            });
            this.initialize();
          });
      }
    },
    handleReplySubmit() {
      this.$http
        .post(
          `forum_posts/${this.blogpost.forum_post_id}/forum_responses.json`,
          {
            forum_response: this.forum_response
          }
        )
        .then(response => {
          this.$notify({
            group: "all",
            title: "Resposta criada!"
          });
          this.forum_response.content = "";
          this.initialize();
        })
        .catch(response => {
          // alert(JSON.stringify(response.data))
        });
    }
  },
  mounted() {
    this.initialize();
  },
  watch: {
    "$route.params.id": function(id) {
      this.initialize();
    }
  }
};
</script>
